import { Collapse } from "react-bootstrap";
import { getExcludePaymentTermText } from "../../../utils";
import Typography from "../../../../../../../common/Typography";
import ChevronDown from "../../../../../../../assets/ChevronDown";
import LayersThree01 from "../../../../../../../assets/LayersThree01";

const ExcludePaymentTerms = ({
  textColor,
  loyaltyType,
  isExcludePaymentCollapse,
  excludedPaymentMethods = [],
  handleExcludePaymentCollapse,
}) => {
  const excludePaymentTermText = getExcludePaymentTermText(loyaltyType);

  return (
    <div className="exclude-item-terms">
      <div
        className="exclude-item-term-head"
        onClick={handleExcludePaymentCollapse}
      >
        <Typography customClass="term" style={{ color: textColor }}>
          {`*${excludePaymentTermText?.replace(".", " :")}`}
        </Typography>
        <ChevronDown
          width={14}
          height={14}
          color={textColor}
          rotate={isExcludePaymentCollapse ? 180 : 0}
        />
      </div>
      <Collapse in={isExcludePaymentCollapse}>
        <div className="exclude-item-term-body">
          {excludedPaymentMethods?.map((method, i) => (
            <div key={`${i}-${method?.name}`} className="category-item-div">
              <div className="category-head">
                <LayersThree01 width={12} height={12} color={textColor} />
                <Typography
                  size="text-xs"
                  weight="medium"
                  style={{
                    color: textColor,
                    textTransform:
                      method?.name === "upi" ? "uppercase" : "capitalize",
                  }}
                >
                  {method?.name}
                </Typography>
              </div>
              <Typography
                size="text-xs"
                customClass="item-names"
                style={{
                  color: textColor,
                }}
              >
                {method?.types?.length > 0 &&
                  method?.types
                    ?.map((type) => {
                      let typeLabel = "";
                      if (!type.startsWith("@"))
                        typeLabel =
                          type.charAt(0).toUpperCase() + type.slice(1);
                      else typeLabel = type;
                      return `• ${typeLabel}`;
                    })
                    ?.join(" ")}
              </Typography>
            </div>
          ))}
        </div>
      </Collapse>
    </div>
  );
};

export default ExcludePaymentTerms;
